import { formatDateBySegmentNoYear, formatDateYear } from "../";

type BenchmarkRow = {
  ts: string;
  consumptionV: number;
  consumptionVM3?: number;
};

type BenchmarkYearData = {
  data: BenchmarkRow[];
  total?:
    | number
    | {
        consumptionV?: number;
        consumptionVM3?: number;
      };
};

export const toBenchmarkDataEnergy = (
  shortSegment: string,
  data: BenchmarkYearData[],
  gettext: (key: string) => string,
  addTotal = false,
) => {
  let returnData: Array<Record<string, string | number>> = [];
  let totals: Record<string, number> = {};
  let totalRow: Record<string, string | number> | null = null;

  data.forEach((yearData) => {
    let ts = yearData?.data[0]?.ts;

    if (ts) {
      const year = formatDateYear(ts);

      if (addTotal) {
        const totalKwh =
          typeof yearData?.total === "number"
            ? yearData.total
            : yearData?.total?.consumptionV || 0;
        const totalM3 =
          typeof yearData?.total === "object" &&
          yearData?.total?.consumptionVM3 !== undefined
            ? yearData.total.consumptionVM3
            : totalKwh / 12.157;

        if (!totalRow) {
          totalRow = {
            id: "Total",
            label: "Sum",
            ts: gettext("Sum"),
          };
        }
        totalRow[`${year}`] = totalKwh;
        totalRow[`${year}_m3`] = totalM3;
      }

      yearData.data.forEach((row) => {
        const date = formatDateBySegmentNoYear(row.ts, shortSegment);
        const m3Value =
          row.consumptionVM3 ??
          (row.consumptionV !== undefined ? row.consumptionV / 12.157 : 0);

        let existingEntry = returnData.find((entry) => entry.ts === date);

        if (existingEntry) {
          existingEntry[year] = row.consumptionV;
          existingEntry[`${year}_m3`] = m3Value;
        } else {
          let rowData: Record<string, string | number> = {
            id: date,
            label: date,
            ts: date,
          };
          rowData[year] = row.consumptionV;
          rowData[`${year}_m3`] = m3Value;
          returnData.push(rowData);
        }

        if (!totals[year]) {
          totals[year] = 0;
        }
        totals[year] += row.consumptionV;
      });
    }
  });

  if (addTotal && totalRow) {
    returnData.push(totalRow);
  }

  return returnData;
};
